import { FC, ReactNode } from "react";
import styles from "./PageTitleBlock.module.scss";

interface IPageTitleBlockProps {
    pageTitle?: string;
    pageDescription?: string | ReactNode;
}

export const PageTitleBlock: FC<IPageTitleBlockProps> = ({ pageTitle, pageDescription }) => {
    return (
        <>
            { <h2 className={styles.title}>{pageTitle}</h2> }
            <p className={styles.subtitle}>{pageDescription}</p>
        </>
    );
};
